<div class="c-lti-missing-content">
  <div
    *ngIf="userType === instructor"
    i18n="@@ltiMissingContent-message-instructor"
    class="c-lti-missing-content__message alert alert-danger"
  >
    This content is no longer available - please update your links to point to
    the correct content
  </div>
  <div
    *ngIf="userType === student"
    i18n="@@ltiMissingContent-message-student"
    class="c-lti-missing-content__message alert alert-danger"
  >
    This content is no longer available - please contact your instructor
  </div>
</div>
